// Note: marketing and affiliate query params are handled separately.

const GENERAL_QUERY_PARAMS = [
    'l', // language param, should be elided if it matches storefront default.
];

/**
 * App-wide query params, not specific to a particular route. If some of these
 * turn out to be route-specific, move them out of `APP_QUERY_PARAMS` and add
 * them to the corresponding page intent controllers' `canonicalUrlRule`.
 */
const APP_QUERY_PARAMS = [...GENERAL_QUERY_PARAMS];

export { APP_QUERY_PARAMS };
